import { FilterType } from './types';
import type { FilterValueUrlParser } from './types';

const multiselectValidator: FilterValueUrlParser<FilterType.AUTOCOMPLETE> = urlValue =>
  urlValue.split(',').filter((v): v is string => typeof v === 'string');

const rangeValidator: FilterValueUrlParser<FilterType.RANGE> = urlValue => {
  if (typeof urlValue !== 'string') {
    return undefined;
  }

  return Number(urlValue);
};

export const numberValidator: FilterValueUrlParser<FilterType.NUMBER> = urlValue => {
  const numValue = parseFloat(urlValue);

  return numValue;
};

const checkboxValidator: FilterValueUrlParser<FilterType.CHECKBOX> = urlValue =>
  urlValue === 'true' ? true : undefined;

export const getFilterValidator = (type: FilterType): FilterValueUrlParser<typeof type> => {
  switch (type) {
    case FilterType.AUTOCOMPLETE:
      return multiselectValidator;
    case FilterType.RANGE:
      return rangeValidator;
    case FilterType.NUMBER:
      return numberValidator;
    case FilterType.CHECKBOX:
      return checkboxValidator;
  }
};
